import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { isEmpty } from "lodash";

import { useStateSelector } from "utils/field";

import { actions as modelActions } from "features/Model/_ducks";

import Button from "components/Button";
import Accordion from "components/Accordion";
import ParagraphInput from "components/paragraphInput";

import classes from "./style.module.scss";
import sharedClasses from "features/Model/sharedStyles.module.scss";

import ErrorIcon from "assets/images/icons/JSX/Tool";

const { flagModelError } = modelActions;

const UserContent = ({ modelName, submitting, errorMessage, setErrorMessage, handleShareClick }) => {
    return (
        <div>
            <div className={classes.orgHeader}>
                <p>
                    File name: <strong>{modelName || "None"}</strong>
                </p>
                <div className={classes.descriptionTextContainer}>
                    <p>
                        Enter an error message below and click the <strong>Flag File</strong> button to share this file
                        with the Volta SNAP developers for review. A Volta SNAP developer will contact you shortly with
                        next steps.
                    </p>
                    <p>Flagging a file twice will overwrite the initial submission.</p>
                </div>
            </div>
            <div className={classes.errorMessageContainer}>
                <ParagraphInput
                    formTitle={"Error Message & Notes"}
                    className={classes.errorMessageInput}
                    placeholder="Please describe the issue you have encountered."
                    disabled={submitting}
                    value={errorMessage}
                    onChange={(val) => {
                        setErrorMessage(val.target.value);
                    }}
                />
            </div>

            <div className={classes.shareButtonContainer}>
                <Button
                    className={classes.shareButton}
                    type="default"
                    onClick={handleShareClick}
                    disabled={errorMessage.replace(/\s/g, "") === "" || submitting}
                >
                    {submitting ? "Submitting..." : "Flag File"}
                </Button>
            </div>
        </div>
    );
};

const DevContent = ({ modelName, submitting, errorDetails, modelErrorSubmitted }) => {
    const { user: userName, email, message } = errorDetails;
    return (
        <div>
            <div className={classes.orgHeader}>
                <p>
                    File name: <strong>{modelName || "None"}</strong>
                </p>
                <p>
                    User name: <strong>{userName || "None"}</strong>
                </p>
                <p>
                    User email: <strong>{email || "None"}</strong>
                </p>
            </div>
            <div className={classes.errorMessageContainer}>
                <ParagraphInput
                    formTitle={"User Error Message & Notes"}
                    className={classes.errorMessageInput}
                    placeholder="No error details provided."
                    disabled={true}
                    value={message}
                />
            </div>
        </div>
    );
};

const ErrorFlagging = ({ flagModelError }) => {
    const uid = useStateSelector(`user.uid`) || {};
    const { VOLTA_DEV = false } = useStateSelector(`user.userPermissions`) || {};
    
    const modelId = useStateSelector(`model.modelId`) || {};
    const { 
        name: modelName = "",
        errorDetails = {},
        modelErrorSubmitted = false
    } = useStateSelector(`model.modelDetails`) || {};

    const [errorMessage, setErrorMessage] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleShareClick = useCallback(async () => {
        setSubmitting(true);
        await flagModelError(modelId, uid, errorMessage);
        setSubmitting(false);
    }, [modelId, uid, errorMessage]);

    return (
        <div className={classes.accordionContainer}>
            <Accordion
                className={sharedClasses.accordion}
                heading={
                    <div className={sharedClasses.accordionIconHeading}>
                        Flag Model Error for Review
                        <ErrorIcon fill={VOLTA_DEV && modelErrorSubmitted ? "#ac0d34" : "#65676A"} />
                    </div>
                }
                large
            >
                {VOLTA_DEV && !isEmpty(errorDetails) ? (
                    <DevContent
                        modelName={modelName}
                        submitting={submitting}
                        errorDetails={errorDetails}
                        modelErrorSubmitted={modelErrorSubmitted}
                    />
                ) : (
                    <UserContent
                        modelName={modelName}
                        submitting={submitting}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        handleShareClick={handleShareClick}
                        modelErrorSubmitted={modelErrorSubmitted}
                    />
                )}
            </Accordion>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => ({
    flagModelError: async (modelId, uid, userMessage) => dispatch(flagModelError(modelId, uid, userMessage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorFlagging);